export default Object.freeze({
  STARTING: 'starting',
  PAUSING: 'pausing',
  RUNNING: 'running',
  PAUSED: 'paused',
  ERRORED: 'errored',
  ARCHIVED: 'archived',
  DRAFT: 'draft',
});
